module.exports = __webpack_public_path__ + "index.2d5b0f94.scss";


//////////////////
// WEBPACK FOOTER
// ./src/screens/WelcomeMessage/index.scss
// module id = 2601
// module chunks = 0